import React from 'react';
import * as S from './SpecialRequestLoader.styles';

const SpecialRequestLoader = () => {
  return (
    <S.SpecialRequestLoader>
      <S.HeaderWithIconWrap>
        <S.SpecialRequestHeader></S.SpecialRequestHeader>
        <S.ArrowDownWrap>
          <S.ArrowDown></S.ArrowDown>
        </S.ArrowDownWrap>
      </S.HeaderWithIconWrap>

      <S.SpecialRequestDescriptionWrap>
        <S.SpecialRequestTitle></S.SpecialRequestTitle>
        <S.SpecialRequestSubTitle></S.SpecialRequestSubTitle>
        <S.SpecialRequestTextarea placeholder="Enter Special Request"></S.SpecialRequestTextarea>
      </S.SpecialRequestDescriptionWrap>
    </S.SpecialRequestLoader>
  );
};

export default SpecialRequestLoader;
